/** Project-level member roles (owner is implicit on workspace owner uid). */
export const PROJECT_MEMBER_ROLES = [
  { value: 'editor', label: 'Editor' },
  { value: 'viewer', label: 'Viewer' },
];

export function normalizeProjectMemberRole(role) {
  return role === 'viewer' ? 'viewer' : 'editor';
}

export function projectRoleLabel(role) {
  const r = normalizeProjectMemberRole(role);
  return r === 'viewer' ? 'Viewer' : 'Editor';
}
